import {loadGLB} from './loadGLB'
import * as THREE from "three";
import getColorObjectOfLargestChild from './utils/getColorObjectOfLargestChild'
import steelMaterial from "./utils/steelMaterial";


export const loadProductIntoScene = async (objectFile, threeViewer) => {
    const product = await loadGLB(objectFile, threeViewer);
    product.name = "product";
    
    //Set product material side to front
    //setAllMaterialSide(product, THREE.FrontSide);
    
    let logo = product?.getObjectByName("logo_main")
    
    //console.log("logo----->", logo)
    
    // Find the product base color
    const colorObject = await getColorObjectOfLargestChild(product);
    const steelMaterialObject = steelMaterial(colorObject)
    
    
    if (logo) {
        logo.layers.set(5) // 5 is the layer which we don't using for raycasting
        let angle = getRadialAngleFromLogo(logo)
        product.rotation.y = angle - Math.PI / 2;
        
        // change logo material
        const steelColor = ['ffffff', 'f5f6f6']
        
        if (steelColor.includes(logo.material.color.getHexString())) {
            
            const newSteel = steelMaterialObject.normal
            
            logo.material.color = newSteel.color
            logo.material.roughness = newSteel.roughness
            logo.material.metalness = newSteel.metalness
            logo.material.roughnessMap = newSteel.roughnessMap
            logo.material.metalnessMap = newSteel.metalnessMap
            logo.material.normalMap = newSteel.normalMap
            logo.material.needsUpdate = true
            logo.needsUpdate = true
            
            
        }
        
    }
    
    addProductInScene(threeViewer, product);
    if (threeViewer.outlinePass) {
        threeViewer.outlinePass.selectedObjects.push(product)
    }
    threeViewer.product = product
    return product;
};



const addProductInScene = (inViewer, inProduct) => {
    
    // Calculate bounding box dimensions
    let box = new THREE.Box3().setFromObject(inProduct);
    let center = box.getCenter(new THREE.Vector3());
    let size = box.getSize(new THREE.Vector3());
    
    inViewer.productSize = size;
    
    // Set camera distance based on diameter
    let widthX = size.x;
    let widthZ = size.z;
    let maxWidth = Math.max(widthX, widthZ);
    inViewer.controls.minDistance = maxWidth * 1.2;
    inViewer.controls.maxDistance = maxWidth * 10;

    inViewer.center = center;
    
    inViewer.scene.add(inProduct);
    inViewer.addDummySketchPlane(size)
};

function getRadialAngleFromLogo(inLogo) {
    inLogo.updateWorldMatrix(true, true)
    // BBox
    let box = new THREE.Box3().setFromObject(inLogo);
    let center = box.getCenter(new THREE.Vector3());
    let center2d = new THREE.Vector2(center.x, center.z)
    center2d.normalize()
    
    // get angle to X axis
    let angle = Math.atan2(center2d.y, center2d.x)
    return angle
}